export default __webpack_public_path__ + "static/media/upgrade-2-img.9e59e1a3.png";